<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
            <div class="container">
                <div class="modal-header">
                    <slot name="header">
                      <span class='t1'><img src="https://app.brighton.com/personalize/static/images/Check.png"/></span>
                      <span class='t2'>Your design has been saved with confirmation #<br/>
                        <span style="color:red" v-if="confirmationNum != null">{{confirmationNum.replace('LOCKETS-', '')}}</span>
                        <span class="small">We will keep your design in our system for 15 days (until {{keepPrintoutUntilDate}})</span>
                      </span> 
                      
                      <span class="printlink"><a :href="printoutPdfFileName" target="_Blank">Print</a></span>
                      <!-- <span class="printlink"><a @click="downloadPrint()">{{downloadText}}</a></span> -->
                      <div v-if="storeType==1" class="consumerOptions">
                        <span  class="printlink" ><a :href="addToCartLink" @click="sendAmulets" target="_Blank">{{addToCartText}}</a></span>
                        or 
                        <br><br>
                        <span><input type="text" v-model="emailAddress" placeholder="YOUR EMAIL ADDRESS"> <button @click="sendEmail">EMAIL</button></span>
                        <span class="emailResult" v-if="emailResult!=''" >{{emailResult}}</span>
                      </div>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                   
                    Would you like to start over and create another?
                    <button class="modal-default-button" @click="$emit('createNew')">
                        CREATE ANOTHER
                    </button>
                    </slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                    <span class="closelink" @click="$emit('close')">NO, CLOSE THIS WINDOW</span>
                    </slot>
                </div>
        </div>
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Step1',
  props: {
    printoutPdfFileName: null,
    confirmationNum: null,
    downloadFileName: null,
    addToCartLink: String,
    storeType: Number,
    selectedAmulets: Array
  },
  data() {
    return {
      emailResult:'',
      emailAddress: '',
      downloadText: 'Download',
      addToCartText: 'Add To Cart'
    }
  },
 computed: {
    keepPrintoutUntilDate () {
      var date = new Date();
      date.setDate(date.getDate() + 15);
      return date.getMonth()+ 1+'/'+date.getDate()+ '/'+date.getFullYear()
    }
 },
  methods:{
    downloadPrint() {
      this.$emit('downloadPrint')
      this.downloadText='Please wait';
      this.$forceUpdate()
      setTimeout(()=>{
        this.downloadText = 'download'
        this.$forceUpdate()
      }, 10000)
    },
    sendAmulets(event) {
      console.log('stop')
      event.preventDefault()
      
      
      if(this.selectedAmulets != null && this.selectedAmulets.length > 0) {
        let url = "https://www.brighton.com/cart?add=12345:1";
          this.selectedAmulets.forEach(selectedAmulet => 
            url += ';'+selectedAmulet.torreyID + ':1'
          )
        let ifrm = document.createElement('iframe')
        ifrm.setAttribute('id', 'ifrm')
        ifrm.setAttribute('src', url)
        // wait for iframe to load before redirecting to make sure all amulets have been sent to torrey first.
        ifrm.onload = ()=>{
          console.log('iframe loaded')
          // console.log(this.addToCartLink)
          this.$emit('getPreviewForCart', {'addToCartLink':this.addToCartLink})
          this.addToCartText = "Please Wait"
        }
        var el = document.getElementById('app')
        el.parentNode.insertBefore(ifrm, el)
      } else {
        this.$emit('getPreviewForCart', {'addToCartLink':this.addToCartLink})
        this.addToCartText = "Please Wait"
      }
    },
    sendEmail(){
      this.emailResult=''
      var that = this
      var apiURL = 'https://app.brighton.com/lockets/api/sendConfirmationEmail';
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(this.emailAddress.trim() == ''){
        this.emailResult = "Email address is required"
      } else if(!re.test(this.emailAddress)) {
        this.emailResult = "Invalid email address"
      } else {
        this.$http.post(
          apiURL,
          {
            'emailAddress':this.emailAddress,
            'confirmationNum':this.confirmationNum.replace('LOCKETS-', '')
          }
          ,
          {emulateJSON: true}
        ).then(response => {
          this.emailResult = "Email sent!"
          setTimeout(function(){
            that.emailResult = ''
          }, 3000)
        })
      }
    }
  }
}
</script>
<style scoped>
.modal-container {
  font-family: 'Lato', 'Avenir', Helvetica, Arial, sans-serif;
  background-color:#ebebeb;
  width: 80%;
  max-width:960px;
  margin: 0px auto;
  color:#666;
  padding: 20px;
  /*background-color: #fff;*/
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;

  /* width:100%; */
  /* max-height: 100%;
  overflow-y: scroll; */
  box-sizing:border-box;


}
.modal-container span.t1{
    font-size:40px;
    display:block;
}
.modal-container span.t2{
  text-align: center;
  display: block;
  margin: 20px auto;
  font-size: 1.5em;
  font-weight: 600;
  letter-spacing: .08em;
}
.modal-container span.t2 .small{
  font-size:12px;
  line-height:1.5;
  text-transform:initial;
  display:block;

}
.modal-container .container {
    border:1px solid #ccc;
    padding:40px;
    box-sizing:border-box;
    max-width: 960px;
    background-color: #fff;
    
}
/*.modal-header{
    border-bottom:1px solid #000;
}*/
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}



.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 40px 0;
  font-size: 1.5em;
}
.closelink{
  color: #5788a2;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 0.1em;
}
.modal-default-button {
  /*float: right;*/
    cursor: pointer;
    display:block;
    padding:10px 30px;
    color:#fff;
    background-color:#5788a2;
    border: none;
    margin:20px auto;
    font-weight: normal;
    font-size:20px;
}
.modal-default-button:hover {
  opacity:0.8;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}



.t2{
  display:block;
  text-transform:uppercase;
}
.printlink{
  display:block;
  font-size:20px;
  padding:10px 0;
  text-transform:uppercase;
  cursor: pointer;
}
.printlink a{
  color:#fff;
  background-color: #5788a2;
  padding:10px 20px;
  text-decoration:none;
  display:block;
  margin: 0 auto;
  width:240px;
  box-sizing:border-box;
}
.printlink a:hover{
  opacity:0.8;
}
.consumerOptions{
  display:block;
}
.consumerOptions span{
  display:block;
  width:100%;
}
.consumerOptions input[type=text]{
  border:1px solid #ccc;
  line-height:1.4;
  padding:11px;
  width: 40%;
  vertical-align: middle;
}
.consumerOptions button{
  /* width:240px; */
  padding: 10px 20px;
    font-size: 20px;
    vertical-align: middle;
    margin:0;
    font-weight:normal;
}

.consumerOptions .emailResult{
  display:block;
  padding:3px 5px;
  text-align:center;
  color:red;
  font-weight: bold;
  text-transform: uppercase;
}
@media(max-width:745px){ 
  .modal-container{
    width:100%;
    height:100%;
    overflow-y:scroll;
  }
  .modal-container .container {
    /* height:100%; */
    /* width:100%; */
    max-width:100%;
    /* overflow-y:scroll; */
  }
}

@media(max-width:498px){
  .home .main .right .container{
    padding:10px 3px;
  }
  .modal-container span.t2,
  .printlink,
  .modal-body,
  .modal-default-button{
    font-size:4vw;
  }





}
</style>
